import React from 'react';
import { Stack, Button } from '@mui/material';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { t } from 'i18next';
import { paths } from '@/routes/paths';
import { IMilestoneSelected } from '@/components/data-display/billing-milestones/types';

export interface SelectedMilestone {
  _id: string;
  total?: number;
}

interface MonthlyDataGroup {
  milestones: SelectedMilestone[];
}

export const getTotal = (items: any[] = []): number =>
  items.reduce((acc, cur) => acc + (cur.total || 0), 0);

export function getSelectedMilestonesByIds(
  milestoneIds: string[],
  groupedMilestonesList: MonthlyDataGroup[]
): SelectedMilestone[] {
  if (!Array.isArray(milestoneIds) || !Array.isArray(groupedMilestonesList)) {
    return [];
  }

  const allMilestones = groupedMilestonesList.flatMap((group) => group.milestones || []);
  const targetIds = new Set(milestoneIds);

  return allMilestones.filter((milestone) => targetIds.has(milestone._id));
}

export const showMilestoneInUseSnackbar = (
  milestone: IMilestoneSelected,
  router: { push: (path: string) => void },
  organizationId: string
) => {
  if (milestone.billingOrders && milestone.billingOrders.length > 0) {
    const billingOrder = milestone.billingOrders[0];
    const billingOrderNumber = billingOrder.number;

    const key = enqueueSnackbar(
      t('This milestone is already being used in billing order N°{{number}}', {
        number: billingOrderNumber.toString().padStart(4, '0'),
      }),
      {
        variant: 'error',
        action: (
          <Stack direction="row" spacing={1}>
            <Button
              size="small"
              variant="contained"
              color="info"
              onClick={() => {
                router.push(
                  paths.management.accounts.organizations.tabEditBillingOrder(
                    organizationId,
                    billingOrder._id
                  )
                );
              }}
            >
              {t('Go to Order')}
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => {
                closeSnackbar(key);
              }}
            >
              {t('Close')}
            </Button>
          </Stack>
        ),
      }
    );
  }
};

export const showMultipleMilestonesInUseSnackbar = () => {
  enqueueSnackbar(t('Some selected milestones are already being used in other billing orders'), {
    variant: 'warning',
  });
};
